import { Flex, Hide } from 'mds-web-ui'
import { ActiveLink } from '@utils/Link'
import React from 'react'

import { GridFlex } from '@utils/Containers'
import { fontSizes } from '@utils/Typography'

export const HeaderLink = ({
  external,
  children,
  fontSize = fontSizes.body,
  ...props
}) => {
  return (
    <ActiveLink
      {...props}
      external={external}
      color="inherit"
      fontSize={fontSize}
    >
      <GridFlex
        gap={1}
        css={{
          '.headerlink__external': {
            transition: 'transform 90ms ease-out'
          },
          '&:hover': {
            '.headerlink__external': {
              transform: 'translateX(4px)'
            }
          }
        }}
      >
        <span>{children}</span>

        {external ? (
          <Hide xs s>
            <Flex as="span" className="headerlink__external">
              →
            </Flex>
          </Hide>
        ) : null}
      </GridFlex>
    </ActiveLink>
  )
}
